export const PROMPT_EDITOR_CHANNEL = 'prompt-template';
export const NEW_VERSION_EVENT = 'newVersion';
